import {
  OrderPaymentStatus,
  OrderStatus,
  OrderType,
} from '../enums/OrderEnums';

export interface IOrderType {
  type: OrderType;
  index: number;
  title: string;
  description: string;
  icon: string;
}

export const ORDER_TYPES: IOrderType[] = [
  {
    type: OrderType.Seat,
    index: 0,
    title: 'A la mesa',
    description: 'Come en el local',
    icon: 'mdi-silverware-fork-knife',
  },
  {
    type: OrderType.Delivery,
    index: 1,
    title: 'A domicilio',
    description: 'Recibelo en casa',
    icon: 'mdi-truck-delivery',
  },
  {
    type: OrderType.Away,
    index: 2,
    title: 'Para retirar',
    description: 'Recogelo en el local',
    icon: 'mdi-bag-personal',
  },
];

export const ORDER_TYPES_MAP = new Map(ORDER_TYPES.map((t) => [t.type, t]));

export const ORDER_STATUSES = [
  {
    id: OrderStatus.Received,
    title: 'Recibido',
    icon: 'mdi-cart-check',
    color: 'teal',
  },
  {
    id: OrderStatus.Canceled,
    title: 'Cancelado',
    icon: 'mdi-close',
    color: 'red',
  },
  {
    id: OrderStatus.Declined,
    title: 'Rechazado',
    icon: 'mdi-close',
    color: 'red',
  },
  {
    id: OrderStatus.Progress,
    title: 'En preparación',
    icon: 'mdi-clock-time-four',
    color: 'yellow',
  },
  {
    id: OrderStatus.ReadyToTake,
    title: 'Listo para retirar',
    icon: 'mdi-archive-arrow-up',
    color: 'blue',
    chipTheme: 'dark',
  },
  {
    id: OrderStatus.Delivering,
    title: 'En camino',
    icon: 'mdi-truck-fast',
    color: 'blue',
    chipTheme: 'dark',
  },
  {
    id: OrderStatus.Finished,
    title: 'Entregado',
    icon: 'mdi-check-bold',
    color: 'green',
    chipTheme: 'dark',
  },
];

export const ORDER_STATUSES_MAP = new Map(ORDER_STATUSES.map((s) => [s.id, s]));

export const ORDER_PAYMENT_STATUSES = [
  {
    id: OrderPaymentStatus.Awaiting,
    title: 'Pendiente',
    icon: 'mdi-clock-time-four',
    color: 'gray',
  },
  {
    id: OrderPaymentStatus.Paid,
    title: 'Pagado',
    icon: 'mdi-check-bold',
    color: 'green',
    chipTheme: 'dark',
  },
  {
    id: OrderPaymentStatus.Declined,
    title: 'Rechazado',
    icon: 'mdi-close',
    color: 'red',
    chipTheme: 'dark',
  },
  {
    id: OrderPaymentStatus.Reimbursed,
    title: 'Rembolsado',
    icon: 'mdi-cash-refund',
    color: 'red',
    chipTheme: 'dark',
  },
  {
    id: OrderPaymentStatus.Partial,
    title: 'Parcial',
    icon: 'mdi-cash',
    color: 'yellow',
  },
];

export const ORDER_PAYMENT_STATUSES_MAP = new Map(
  ORDER_PAYMENT_STATUSES.map((s) => [s.id, s])
);
